import { memo } from 'react';

const icons = import.meta.glob('../../icons/*.svg', { eager: true, query: '?react' });

export const Icon = memo(function Icon({ name, ...props }) {
  const SvgIcon = icons[`../../icons/${name}.svg`]?.default;
  return !SvgIcon ? null : <SvgIcon {...props} />;
});